module.exports = __webpack_public_path__ + "static/media/EC.91b72b57.webp";